export const DOCS_API = '/agentdocs/docs';
export const GENERATE_API = '/agentdocs/generate/link';
